<template>
    <div class="spinner-cs border border-dark p-2 rounded bg-white">
        <CSpinner />
    </div>
</template>
<script>
export default {}
</script>
